import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { IntercompanyObjectFragmentDoc } from './intercompanyObject';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DealIntercompanyObjectsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DealIntercompanyObjectsQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: number, intercompanyObjects?: Array<{ __typename?: 'IntercompanyObject', id: string, role?: Types.RoleEnum | null, relationType?: Types.RelationEnum | null, foreignObjectId?: string | null, foreignObjectType: string, foreignRegion: string, foreignDealId?: string | null, foreignRole?: Types.RoleEnum | null, foreignObjectNumber?: string | null, archivedAt?: string | null }> | null } | null };


export const DealIntercompanyObjectsDocument = gql`
    query dealIntercompanyObjects($id: ID!) {
  deal(id: $id) {
    id
    intercompanyObjects {
      ...intercompanyObject
    }
  }
}
    ${IntercompanyObjectFragmentDoc}`;

/**
 * __useDealIntercompanyObjectsQuery__
 *
 * To run a query within a React component, call `useDealIntercompanyObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealIntercompanyObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealIntercompanyObjectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealIntercompanyObjectsQuery(baseOptions: Apollo.QueryHookOptions<DealIntercompanyObjectsQuery, DealIntercompanyObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealIntercompanyObjectsQuery, DealIntercompanyObjectsQueryVariables>(DealIntercompanyObjectsDocument, options);
      }
export function useDealIntercompanyObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealIntercompanyObjectsQuery, DealIntercompanyObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealIntercompanyObjectsQuery, DealIntercompanyObjectsQueryVariables>(DealIntercompanyObjectsDocument, options);
        }
export function useDealIntercompanyObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DealIntercompanyObjectsQuery, DealIntercompanyObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DealIntercompanyObjectsQuery, DealIntercompanyObjectsQueryVariables>(DealIntercompanyObjectsDocument, options);
        }
export type DealIntercompanyObjectsQueryHookResult = ReturnType<typeof useDealIntercompanyObjectsQuery>;
export type DealIntercompanyObjectsLazyQueryHookResult = ReturnType<typeof useDealIntercompanyObjectsLazyQuery>;
export type DealIntercompanyObjectsSuspenseQueryHookResult = ReturnType<typeof useDealIntercompanyObjectsSuspenseQuery>;
export type DealIntercompanyObjectsQueryResult = Apollo.QueryResult<DealIntercompanyObjectsQuery, DealIntercompanyObjectsQueryVariables>;